var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookAppSymbol1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-app-symbol_1_",
    "data-name": "facebook-app-symbol (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.79,
    height: 26.557,
    viewBox: "0 0 13.79 26.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M46.242,26.557V14.444h4.064l.61-4.722H46.242V6.707c0-1.367.378-2.3,2.34-2.3h2.5V.185A33.876,33.876,0,0,0,47.439,0c-3.6,0-6.072,2.2-6.072,6.24V9.722H37.29v4.722h4.076V26.557Z",
    transform: "translate(-37.29)",
    fill: "#231c5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAppSymbol1);
export default __webpack_public_path__ + "static/media/facebook-app-symbol (1).1abb8311fbb16c0bd0e71c89fd7e914c.svg";
export { ForwardRef as ReactComponent };